import React from 'react'
import PropTypes from 'prop-types'
import sanitizedContentData from '@/components/shared/utils/sanitizedContentData'
import { motion } from 'framer-motion'
import { get } from 'lodash'
// styles
import './styles.ol.scss'

const Content = (props) => {
  const { data } = props

  return (
    <motion.div
      transition={{
        duration: 0.7,
        delay: 0.1,
      }}
      viewport={{
        once: true,
      }}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      exit={{ opacity: 1 }}
      className="content"
    >
      <label>{get(data, ['title'], '')}</label>
      <div
        className="description"
        dangerouslySetInnerHTML={sanitizedContentData(get(data, ['description'], ''))}
      />
    </motion.div>
  )
}

Content.propTypes = {
  data: PropTypes.object,
}

export default Content
